import { render } from "./App.vue?vue&type=template&id=007fe8e4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=007fe8e4&lang=css"
script.render = render

export default script